import React from "react";
import Card from "components/ui/Card/Card";
import classNames from "classnames";
import type { StatCard } from "../dashboardData";
import styles from "./StatsGrid.module.scss";
import { useI18n } from "context/I18nContext";

type Props = {
  items: StatCard[];
  loading?: boolean;
  placeholderCount?: number;
  emptyMessage?: string;
};

function StatsGrid({
  items,
  loading = false,
  placeholderCount = 4,
  emptyMessage,
}: Props) {
  const { t } = useI18n();
  const resolvedEmpty = emptyMessage ?? t("dashboardPage.stats.empty");

  if (loading) {
    return (
      <div className={styles.grid}>
        {Array.from({ length: placeholderCount }).map((_, index) => (
          <Card
            key={`stat-placeholder-${index}`}
            className={classNames(styles.card, styles.placeholder)}
          >
            <div className={styles.value} />
            <div className={styles.label} />
          </Card>
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className={styles.grid}>
        <Card className={classNames(styles.card, styles.emptyCard)}>
          <div className={styles.emptyMessage}>{resolvedEmpty}</div>
        </Card>
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {items.map((item) => (
        <Card
          key={item.label}
          className={styles.card}
          style={{ background: item.gradient }}
        >
          <div className={styles.value}>{item.value}</div>
          <div className={styles.label}>{item.label}</div>
        </Card>
      ))}
    </div>
  );
}

export default StatsGrid;
